<template>
  <div id="dashboard-analytics">
    
    <div class="mb-8">
      <h2 class="mb-1">{{ $t('DashboardOverview') }}</h2>
      <p class="opacity-75">{{ $t('Keymetricsandrecentactivityacrosstheplatform') }}</p>
    </div>

  <div class="vx-row mb-base">
  
  <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 mb-base">
    <vx-card class="p-2">
      <p class="text-sm opacity-75 mb-3 font-medium">{{ $t('TotalInvestors') }}</p>
      
      <div class="flex items-end justify-between">
        <div>
          <small class="text-grey display-block mb-1" style="font-size: 0.7rem;">{{ $t('Total') }}</small>
          <h1 class="font-bold leading-none">{{ totalStats.investors }}</h1>
        </div>

        <div class="text-right">
          <small class="text-success display-block mb-1" style="font-size: 0.7rem;">{{ $t('Today') }}</small>
          <h2 class="font-bold text-success leading-none">{{ todayStats.investors }}</h2>
        </div>
      </div>
    </vx-card>
  </div>

  <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 mb-base">
    <vx-card class="p-2">
      <p class="text-sm opacity-75 mb-3 font-medium">{{ $t('Properties') }}</p>
      <div class="flex items-end justify-between">
        <div>
          <small class="text-grey display-block mb-1" style="font-size: 0.7rem;">{{ $t('Total') }}</small>
          <h1 class="font-bold leading-none">{{ totalStats.properties }}</h1>
        </div>
        <div class="text-right">
          <small class="text-primary display-block mb-1" style="font-size: 0.7rem;">{{ $t('Today') }}</small>
          <h2 class="font-bold text-primary leading-none">{{ todayStats.properties }}</h2>
        </div>
      </div>
    </vx-card>
  </div>

  <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 mb-base">
    <vx-card class="p-2">
      <p class="text-sm opacity-75 mb-3 font-medium">{{ $t('OpenOpportunities') }}</p>
      <div class="flex items-end justify-between">
        <div>
          <small class="text-grey display-block mb-1" style="font-size: 0.7rem;">{{ $t('Total') }}</small>
          <h1 class="font-bold leading-none">{{ totalStats.opportunities }}</h1>
        </div>
        <div class="text-right">
          <small class="text-warning display-block mb-1" style="font-size: 0.7rem;">{{ $t('Today') }}</small>
          <h2 class="font-bold text-warning leading-none">{{ todayStats.opportunities }}</h2>
        </div>
      </div>
    </vx-card>
  </div>

  <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 mb-base">
    <vx-card class="p-2">
      <p class="text-sm opacity-75 mb-3 font-medium">{{ $t('PurchaseOrders') }}</p>
      <div class="flex items-end justify-between">
        <div>
          <small class="text-grey display-block mb-1" style="font-size: 0.7rem;">{{ $t('Total') }}</small>
          <h1 class="font-bold leading-none">{{ totalStats.orders }}</h1>
        </div>
        <div class="text-right">
          <small class="text-danger display-block mb-1" style="font-size: 0.7rem;">{{ $t('Today') }}</small>
          <h2 class="font-bold text-danger leading-none">{{ todayStats.orders }}</h2>
        </div>
      </div>
    </vx-card>
  </div>

</div>
    <div class="vx-row">
      
      <div class="vx-col w-full md:w-1/2 mb-base">
        <vx-card :title="$t('LatestInvestors')">
          <vs-table :data="latestInvestorsData">
            <template slot="thead">
              <vs-th>{{ $t("Code") }}</vs-th>
              <vs-th>{{ $t("Name") }}</vs-th>
              <vs-th>{{ $t("Nationality") }}</vs-th>
              <vs-th>{{ $t("Status") }}</vs-th>
            </template>

            <template slot-scope="{data}">
              <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                <p class="font-medium cursor-pointer text-primary" @click="AddOrEditInvestor(tr)">
                    {{ tr.InvestorCode }}
                  </p>
                <vs-td>{{ tr.UserFullNameAr }}</vs-td>
                <vs-td>{{ getNationalityName(tr.NationalityId) }}</vs-td>
                <vs-td>
                  <vs-chip :color="tr.isActive ? 'success' : 'warning'" transparent>
                    {{ tr.isActive ? $t('Active') : $t('Pending') }}
                  </vs-chip>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </vx-card>
      </div>

      <div class="vx-col w-full md:w-1/2 mb-base">
        <vx-card :title="$t('LatestOpportunities')">
          <vs-table :data="latestOpportunitiesData">
            <template slot="thead">
              <vs-th>{{ $t("Code") }}</vs-th>
              <vs-th>{{ $t("Property") }}</vs-th>
              <vs-th>{{ $t("Price") }}</vs-th>
              <vs-th>{{ $t("Status") }}</vs-th>
            </template>

            <template slot-scope="{data}">
              <vs-tr :key="indextr" v-for="(tr, indextr) in data">
               <p class="font-medium cursor-pointer text-primary" @click="AddOrEditData(tr)">
                    {{ tr.OpportunityCode }}
                  </p>
                <vs-td>  {{ currentLocale === 'ar' ? tr.OpportunityNameAr : tr.OpportunityNameEn }}</vs-td>
               <vs-td>
                  {{ (tr.TokenPrice * tr.TotalTokens).toLocaleString() }} SAR
                </vs-td>
                <vs-td>
                  <vs-chip color="primary" transparent>{{ $t('Open') }}</vs-chip>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </vx-card>
      </div>

    </div>
  </div>
</template>

<script>
import moduleInvestors from "@/store/Investors/moduleInvestors.js";
import moduleProperties from "@/store/Properties/moduleProperties.js";
import moduleOpportunities from "@/store/Opportunities/moduleOpportunities.js";
import modulePurchaseOrders from "@/store/PurchaseOrders/modulePurchaseOrders.js";
import moduleNationalities from "@/store/Nationality/moduleNationalities.js";
import { computed } from "vue";
export default {
  data() {
    return {

    }
  },
computed: {
    currentLocale() { return this.$i18n.locale; },
    

    Investors() { return this.$store.state.InvestorsList.Investors || []; },
    Properties() { return this.$store.state.PropertiesList.Properties || []; },
    Opportunities() { return this.$store.state.OpportunitiesList.Opportunities || []; },
    PurchaseOrders() { return this.$store.state.PurchaseOrdersList.PurchaseOrders || []; },
    Nationalities() { return this.$store.state.NationalitiesList.Nationalities || []; },

   todayStats() {

  const date = new Date();
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const today = `${year}-${month}-${day}`;

  return {
    investors: this.Investors.filter(item => 
      item.CreatedAt && item.CreatedAt.includes(today)
    ).length,
    
    properties: this.Properties.filter(item => 
      item.CreatedAt && item.CreatedAt.includes(today)
    ).length,
    
    opportunities: this.Opportunities.filter(item => 
      item.CreatedAt && item.CreatedAt.includes(today)
    ).length,
    
    orders: this.PurchaseOrders.filter(item => 
      item.CreatedAt && item.CreatedAt.includes(today)
    ).length
  };
},
    totalStats() {
      return {
        investors: this.Investors.length,
        properties: this.Properties.length,
        opportunities: this.Opportunities.length,
        orders: this.PurchaseOrders.length
      };
    },

    latestInvestorsData() {
      return [...this.Investors]
        .sort((a, b) => {
          return new Date(b.CreatedAt) - new Date(a.CreatedAt);
        })
        .slice(0, 5);
    },
   latestOpportunitiesData() {
      return [...this.Opportunities]
        .sort((a, b) => {
          
          return new Date(b.CreatedAt) - new Date(a.CreatedAt);
        })
        .slice(0, 5);
    }
},
  methods: {
   getNationalityName(id) {
      
        if (!this.Nationalities || this.Nationalities.length === 0) return "...";
        
        const item = this.Nationalities.find(x => x.Id === id);
        if (!item) return "";

        return this.currentLocale === 'ar' ? item.NationalityNameAr : item.NationalityNameEn; 

    },
    AddOrEditInvestor(data) {
        const id = data.Id || 0;
        this.$router.push(`/Investors/AddOrEditInvestor/${id}`);
    },

    AddOrEditData(data) {
        const id = data.Id || 0;
        this.$router.push(`/Opportunities/AddOrEditOpportunities/${id}`);
    }
  },
  created() {
   if (!moduleInvestors.isRegistered) {
      this.$store.registerModule("InvestorsList", moduleInvestors);
      moduleInvestors.isRegistered = true;
    }
    if (!moduleProperties.isRegistered) {
      this.$store.registerModule("PropertiesList", moduleProperties);
      moduleProperties.isRegistered = true;
    }
    if (!moduleOpportunities.isRegistered) {
      this.$store.registerModule("OpportunitiesList", moduleOpportunities);
      moduleOpportunities.isRegistered = true;
    }
     if (!modulePurchaseOrders.isRegistered) {
      this.$store.registerModule("PurchaseOrdersList", modulePurchaseOrders);
      modulePurchaseOrders.isRegistered = true;
    }
      if (!moduleNationalities.isRegistered) {
      this.$store.registerModule("NationalitiesList", moduleNationalities);
      moduleNationalities.isRegistered = true;
    }

      this.$store.dispatch("InvestorsList/fetchDataListItems");
      this.$store.dispatch("PropertiesList/fetchDataListItems");
      this.$store.dispatch("OpportunitiesList/fetchDataListItems");
      this.$store.dispatch("PurchaseOrdersList/fetchDataListItems");
      this.$store.dispatch("NationalitiesList/fetchDataListItems");
  }
}
</script>

<style lang="scss">
#dashboard-analytics {
  .vx-card {
    box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05) !important;
  }
  h1 {
    font-size: 2rem;
  }
}
</style>